import React from 'react';
import PropTypes from 'prop-types';

import { snakeToCaps } from '~/helpers/formatting';
import Accordion from '~/components/Accordion';

const FinancialPropTypes = {
  financial: PropTypes.shape({
    credit: PropTypes.arrayOf(PropTypes.shape({
      models: PropTypes.shape({}),
      derogatory_marks: PropTypes.shape({}),
    })),
  }),
};

const FinancialDefaultProps = {
  financial: null,
};

const ReportTypes = {
  FINANCIAL_REPORTS: 'Financial Reports',
  DEROGATORY_MARKS: 'Derogatory Remarks',
};

function Financial(props) {
  const { financial } = props;

  const getFinancialReports = credit => {
    if (credit && Object.keys(credit).length) {
      return (
        Object.keys(credit).map(model => (
          <div key={model} className="flex full-space">
            <p className="bold small-text">
              {credit[model].name}
              :
            </p>
            <p className="small-text">
              {/* In some cases, model score will be an object. Convert to string to render */}
              {typeof credit[model].score === 'object'
                ? JSON.stringify(credit[model].score)
                : credit[model].score}
            </p>
          </div>
        )));
    }
    return (<p className="light-grey small-text"><i>No financial reports found</i></p>);
  };

  const getDerogatoryRemarks = derogatoryMarks => {
    if (derogatoryMarks && Object.keys(derogatoryMarks).length) {
      return (Object.keys(derogatoryMarks).map(key => (
        <div key={key} className="grey flex full-space">
          <p className="small-text">
            {snakeToCaps(key)}
            :
          </p>
          <p className="small-text">
            {derogatoryMarks[key]}
          </p>
        </div>
      )));
    }
    return (<p className="light-grey small-text"><i>No derogatory marks found</i></p>);
  };

  let creditModels = {};
  let derogatoryMarks = {};

  const hasFinancials = financial && {}.hasOwnProperty.call(financial, 'credit') && financial.credit.length;

  if (hasFinancials) {
    financial.credit.forEach(credit => {
      creditModels = { ...creditModels, ...credit.models };
      derogatoryMarks = { ...derogatoryMarks, ...credit.derogatory_marks };
    });
  }

  return (
    <div>
      {/* rendering credit for the time being: need specific order & banking data unknown */}
      {hasFinancials
        ? (
          <>
            <Accordion title={ReportTypes.FINANCIAL_REPORTS}>
              {getFinancialReports(creditModels)}
            </Accordion>
            <Accordion title={ReportTypes.DEROGATORY_MARKS}>
              {getDerogatoryRemarks(derogatoryMarks)}
            </Accordion>
          </>
        )
        : (
          <>
            <Accordion title={ReportTypes.FINANCIAL_REPORTS}>
              {getFinancialReports()}
            </Accordion>
            <Accordion title={ReportTypes.DEROGATORY_MARKS}>
              {getDerogatoryRemarks()}
            </Accordion>
          </>
        )}
    </div>
  );
}
Financial.propTypes = FinancialPropTypes;
Financial.defaultProps = FinancialDefaultProps;

export default Financial;
